import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import useLocalization from 'hooks/useLocalization'
import { observer } from 'mobx-react'
import FormFieldset from '../../../../UI/AsideModal/Form/FormFieldset'

const RequiredFieldsMeetingModal = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'deals',
    dict: {
      city: 'Город',
      select_city: 'Выберите город',
      program: 'Программа',
      select_program: 'Выберите программу',
      budget: 'Бюджет',
      year_of_study: 'Класс/Курсс',
      select_year_of_study: 'Выберите класс/курсс',
      level: 'Уровень английского',
      select_level: 'Выберите уровень',
      country: 'Страна поступления',
      planned_specialty: 'Специальность',
      meeting_format: 'Формат встречи',
      select_meeting_format: 'Выберите формат',
      consultation_date: 'Дата и время встречи',
    },
  })

  return (
    <FormFieldset>
      <FormField>
        <FormLabel isRequired>{translate.city}:</FormLabel>
        <SelectCustom
          placeholder={translate.select_city}
          apiConfParams={{ limit: 99 }}
          apiLinkCRM='integration/cities'
          sortKey='name'
          valueID={modalValue.city}
          onChange={(city) => changeValues(city.id, 'city')}
          isSearchable
          error={check('city')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{translate.program}:</FormLabel>
        <SelectCustom
          placeholder={translate.select_program}
          apiLinkCRM='integration/programs'
          sortKey='name'
          valueID={modalValue.program}
          onChange={(program) => changeValues(program.id, 'program')}
          isSearchable
          error={check('program')}
        />
      </FormField>

      <FormField>
        <FormLabel>{translate.budget}:</FormLabel>
        <FormInput
        // isError={check('budget')}
        >
          <input
            type='number'
            value={modalValue.budget || ''}
            onChange={(e) => changeValues(e.target.value, 'budget')}
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel isRequired>{translate.year_of_study}:</FormLabel>
        <SelectCustom
          placeholder={translate.select_year_of_study}
          apiLinkCRM='settings/project_settings/deal_year_of_study_choices'
          apiGetResult={(result) => result.value.choices}
          valueID={modalValue.year_of_study}
          optionLabelKey='name'
          optionValueKey='name'
          onChange={(val) => changeValues(val.name, 'year_of_study')}
          isSearchable
          error={check('year_of_study')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{translate.level}:</FormLabel>
        {/*<SelectCustom*/}
        {/*  placeholder={translate?.select_level}*/}
        {/*  apiLinkCRM='integration/teaching_levels'*/}
        {/*  sortKey='name'*/}
        {/*  valueID={modalValue.level}*/}
        {/*  onChange={(level) => changeValues(level.id, 'level')}*/}
        {/*  isSearchable*/}
        {/*  error={check('level')}*/}
        {/*/>*/}
        <FormInput isError={check('level_result')}>
          <input
            placeholder={'Уровень английского'}
            type='text'
            value={modalValue.level_result || ''}
            onChange={(e) => changeValues(e.target.value, 'level_result')}
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel>{'Страна поступления'}:</FormLabel>
        <SelectCustom
          placeholder={'Страна поступления'}
          apiLinkCRM='settings/project_settings/deal_country_of_admission_choices'
          apiGetResult={(result) => result.value.choices}
          valueID={modalValue.country_of_admission}
          optionLabelKey='name'
          optionValueKey='name'
          onChange={(val) => changeValues(val.name, 'country_of_admission')}
          isSearchable
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{translate.planned_specialty}:</FormLabel>
        <FormInput isError={check('planned_specialty')}>
          <input
            placeholder={translate.planned_specialty}
            type='text'
            value={modalValue.planned_specialty || ''}
            onChange={(e) => changeValues(e.target.value, 'planned_specialty')}
          />
        </FormInput>
      </FormField>
    </FormFieldset>
  )
}

export default observer(RequiredFieldsMeetingModal)
